
  import { Vue, Component, Prop } from "vue-property-decorator";

  import Card from "@/components/card/Card.vue";
  import UIButton from "@/components/button/ui-button.vue";
  import CardBodyItem from "@/components/card/CardBodyItem.vue";
  import TableAvatar from "@/components/table/TableAvatar.vue";
  import CollapsibleDescription from "@/components/common/CollapsibleDescription.vue";
  import NotificationOffIcon from "@/components/icons/NotificationOffIcon.vue";
  import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
  import ColorIconContainer from "@/components/icons/ColorIconContainer.vue";
  import CompanyNotificationsButton from "@/components/company/CompanyNotificationsButton.vue"
  import ChatIcon from "@/components/icons/ChatIcon.vue";

  import { NO_INFORMATION } from "@/data/placeholders";
  import RouteNames from "@/entities/RouteNames";


  @Component({
    components: {
      Card,
      UIButton,
      CardBodyItem,
      TableAvatar,
      CollapsibleDescription,
      NotificationOffIcon,
      CircleWithInitials,
      ColorIconContainer,
      CompanyNotificationsButton,
      ChatIcon,
    },
  })
  export default class CompanyCard extends Vue {
    @Prop({ type: String, default: undefined }) readonly companyName?: string;
    @Prop({ type: String, default: undefined }) readonly country?: string;
    @Prop({ type: String, default: undefined }) readonly state?: string;
    @Prop({ type: String, default: undefined }) readonly city?: string;
    @Prop({ type: String, default: undefined }) readonly postalCode?: string;
    @Prop({ type: Number, default: undefined }) readonly phoneNumber?: number;
    @Prop({ type: String, default: undefined }) readonly website?: string;
    @Prop({ type: String, default: undefined }) readonly industry?: string;
    @Prop({ type: String, default: undefined }) readonly description?: string;
    @Prop({ type: String, default: undefined }) readonly avatar?: string;
    @Prop({ type: String, default: undefined }) readonly address1?: string;
    @Prop({ type: String, default: undefined }) readonly address2?: string;
    @Prop({ type: Array, required: true }) readonly disabledNotifications!: { [id: string]: string }[];
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: String, required: true }) readonly currentUserId!: string;

    placeholder: string = NO_INFORMATION;
    processing: boolean = false;
    routeNames = RouteNames;
    notificationsDisabledVal: boolean | null = null;

    get notificationsDisabled(): boolean {
      if (this.notificationsDisabledVal === null) {
        return this.disabledNotifications.length > 0;
      }
      return this.notificationsDisabledVal!;
    } 

    set notificationsDisabled(status: boolean) {
      this.notificationsDisabledVal = status;
    }

    get address(): string | undefined {
      if (!this.address1 && !this.address2) {
        return undefined;
      }
      if (this.address1 && this.address2) {
        return `${this.address1} ${this.address2}`;
      }
      return this.address1 || this.address2;
    }
  }
